import Before1 from '../../../image/Gallery/CrouchHill/Before1.jpg'
import Before2 from '../../../image/Gallery/CrouchHill/Before2.jpg'
import Before3 from '../../../image/Gallery/CrouchHill/Before3.jpg'
import Before4 from '../../../image/Gallery/CrouchHill/Before4.jpg'
import Project1 from '../../../image/Gallery/CrouchHill/Project1.jpg'
import Project2 from '../../../image/Gallery/CrouchHill/Project2.jpg'
import moment1 from '../../../image/Gallery/CrouchHill/Workmoment1.jpg'
import moment2 from '../../../image/Gallery/CrouchHill/Workmoment2.jpeg'
import moment3 from '../../../image/Gallery/CrouchHill/Workmoment3.jpeg'
import moment4 from '../../../image/Gallery/CrouchHill/Workmoment4.jpeg'
import moment5 from '../../../image/Gallery/CrouchHill/Workmoment5.jpeg'
import moment6 from '../../../image/Gallery/CrouchHill/Workmoment6.jpeg'
import moment7 from '../../../image/Gallery/CrouchHill/Workmoment7.jpg'
import moment8 from '../../../image/Gallery/CrouchHill/Workmoment8.jpg'
import moment9 from '../../../image/Gallery/CrouchHill/Workmoment9.jpg'
import moment10 from '../../../image/Gallery/CrouchHill/Workmoment10.jpg'
import moment11 from '../../../image/Gallery/CrouchHill/Workmoment11.jpg'
import moment12 from '../../../image/Gallery/CrouchHill/Workmoment12.jpg'
import moment13 from '../../../image/Gallery/CrouchHill/Workmoment13.jpg'
import moment14 from '../../../image/Gallery/CrouchHill/Workmoment14.jpg'
import moment15 from '../../../image/Gallery/CrouchHill/Workmoment15.jpg'
import Read1 from '../../../image/Gallery/CrouchHill/Read1.jpg'
import Read2 from '../../../image/Gallery/CrouchHill/Read2.jpg'
import Read3 from '../../../image/Gallery/CrouchHill/Read3.jpg'
import Read4 from '../../../image/Gallery/CrouchHill/Read4.jpg'
import Read5 from '../../../image/Gallery/CrouchHill/Read5.jpg'
import Read6 from '../../../image/Gallery/CrouchHill/Read6.jpg'
import Read7 from '../../../image/Gallery/CrouchHill/Read7.jpg'
import Read8 from '../../../image/Gallery/CrouchHill/Read8.jpg'
import Read9 from '../../../image/Gallery/CrouchHill/Read9.jpg'
import Read10 from '../../../image/Gallery/CrouchHill/Read10.jpg'
import Ready11 from '../../../image/Gallery/CrouchHill/Ready11.jpg'

import eBefore1 from '../../../image/Gallery/EastFinchley/Before1.jpg'
import eBefore2 from '../../../image/Gallery/EastFinchley/Before2.jpg'
import eBefore3 from '../../../image/Gallery/EastFinchley/Before3.jpg'
import eProject1 from '../../../image/Gallery/EastFinchley/Project1.jpg'
import eProject2 from '../../../image/Gallery/EastFinchley/Project2.jpg'
import eProject3 from '../../../image/Gallery/EastFinchley/Project3.jpg'
import eProject4 from '../../../image/Gallery/EastFinchley/Project4.jpg'
import eProject5 from '../../../image/Gallery/EastFinchley/Project5.jpg'
import eReady1 from '../../../image/Gallery/EastFinchley/Ready1.jpg'
import eReady2 from '../../../image/Gallery/EastFinchley/Ready2.jpg'
import eReady3 from '../../../image/Gallery/EastFinchley/Ready3.jpg'
import eReady4 from '../../../image/Gallery/EastFinchley/Ready4.jpg'
import eReady5 from '../../../image/Gallery/EastFinchley/Ready5.jpg'
import eReady6 from '../../../image/Gallery/EastFinchley/Ready6.jpg'
import eReady7 from '../../../image/Gallery/EastFinchley/Ready7.jpg'
import eReady8 from '../../../image/Gallery/EastFinchley/Ready8.jpg'
import eReady9 from '../../../image/Gallery/EastFinchley/Ready9.jpg'
import eReady10 from '../../../image/Gallery/EastFinchley/Ready10.jpg'
import eReady11 from '../../../image/Gallery/EastFinchley/Ready11.jpg'
import eReady12 from '../../../image/Gallery/EastFinchley/Ready12.jpg'

import hProject1 from '../../../image/Gallery/HadleyWood/Project1.jpg'
import hProject2 from '../../../image/Gallery/HadleyWood/Project2.jpg'
import hProject3 from '../../../image/Gallery/HadleyWood/Project3.jpg'
import hProject4 from '../../../image/Gallery/HadleyWood/Project4.jpg'
import hProject5 from '../../../image/Gallery/HadleyWood/Project5.jpg'
import hProject6 from '../../../image/Gallery/HadleyWood/Project6.jpg'
import hProject7 from '../../../image/Gallery/HadleyWood/Project7.jpg'
import hProject8 from '../../../image/Gallery/HadleyWood/Project8.jpg'
import hProject9 from '../../../image/Gallery/HadleyWood/Project9.jpg'
import hReady1 from '../../../image/Gallery/HadleyWood/Ready1.jpg'
import hReady2 from '../../../image/Gallery/HadleyWood/Ready2.jpg'
import hReady3 from '../../../image/Gallery/HadleyWood/Ready3.jpg'
import hReady4 from '../../../image/Gallery/HadleyWood/Ready4.jpg'
import hReady5 from '../../../image/Gallery/HadleyWood/Ready5.jpg'
import hReady6 from '../../../image/Gallery/HadleyWood/Ready6.jpg'
import hReady7 from '../../../image/Gallery/HadleyWood/Ready7.jpg'
import hReady8 from '../../../image/Gallery/HadleyWood/Ready8.jpg'
import hReady9 from '../../../image/Gallery/HadleyWood/Ready9.jpg'
import hReady10 from '../../../image/Gallery/HadleyWood/Ready10.jpg'
import hReady11 from '../../../image/Gallery/HadleyWood/Ready11.jpg'
import hReady12 from '../../../image/Gallery/HadleyWood/Ready12.jpg'
import hReady13 from '../../../image/Gallery/HadleyWood/Ready13.jpg'

import lBefore1 from '../../../image/Gallery/Loughton/Before1.jpg'
import lBefore2 from '../../../image/Gallery/Loughton/Before2.jpg'
import lProjectPic1 from '../../../image/Gallery/Loughton/ProjectPic1.jpg'
import lProjectPic2 from '../../../image/Gallery/Loughton/ProjectPic2.jpg'
import lProjectPic3 from '../../../image/Gallery/Loughton/ProjectPic3.jpg'
import lProjectPic4 from '../../../image/Gallery/Loughton/ProjectPic4.jpg'
import lProjectPic5 from '../../../image/Gallery/Loughton/ProjectPic5.jpg'
import lProjectPic6 from '../../../image/Gallery/Loughton/ProjectPic6.jpg'
import lReady1 from '../../../image/Gallery/Loughton/Ready1.jpg'
import lReady2 from '../../../image/Gallery/Loughton/Ready2.jpg'
import lReady3 from '../../../image/Gallery/Loughton/Ready3.jpg'
import lReady4 from '../../../image/Gallery/Loughton/Ready4.jpg'
import lReady5 from '../../../image/Gallery/Loughton/Ready5.jpg'
import lmoment2 from '../../../image/Gallery/Loughton/Workmoment2.jpg'
import lmoment from '../../../image/Gallery/Loughton/Workmoment.jpg'

import mBefore1New from '../../../image/Gallery/MuswellHill/before1New.jpg'
import mBefore2New from '../../../image/Gallery/MuswellHill/before2New.jpg'
import mBefore3New from '../../../image/Gallery/MuswellHill/before3New.jpg'
import mBefore4New from '../../../image/Gallery/MuswellHill/before4New.jpg'
import mBefore1 from '../../../image/Gallery/MuswellHill/Before1.jpg'
import mBefore2 from '../../../image/Gallery/MuswellHill/Before2.jpg'
import mBefore3 from '../../../image/Gallery/MuswellHill/Before3.jpg'
import mBefore4 from '../../../image/Gallery/MuswellHill/Before4.jpg'
import mProject1 from '../../../image/Gallery/MuswellHill/Project1.jpg'
import mProject2 from '../../../image/Gallery/MuswellHill/Project2.jpg'
import mProject3 from '../../../image/Gallery/MuswellHill/Project3.jpg'
import mProject4 from '../../../image/Gallery/MuswellHill/Project4.jpg'
import mProject5 from '../../../image/Gallery/MuswellHill/Project5.jpg'
import mProject6 from '../../../image/Gallery/MuswellHill/Project6.jpg'
import mProject7 from '../../../image/Gallery/MuswellHill/Project7.jpg'
import mProject8 from '../../../image/Gallery/MuswellHill/Project8.jpg'
import mProject9 from '../../../image/Gallery/MuswellHill/Project9.jpg'
import mProject10 from '../../../image/Gallery/MuswellHill/Project10.jpg'
import mMoment1 from '../../../image/Gallery/MuswellHill/Workmoment1.jpg'
import mMoment2 from '../../../image/Gallery/MuswellHill/Workmoment2.jpg'
import mMoment3 from '../../../image/Gallery/MuswellHill/Workmoment3.jpg'
import mMoment4 from '../../../image/Gallery/MuswellHill/Workmoment4.jpg'
import mMoment5 from '../../../image/Gallery/MuswellHill/Workmoment5.jpg'
import mMoment6 from '../../../image/Gallery/MuswellHill/Workmoment6.jpg'
import mMoment7 from '../../../image/Gallery/MuswellHill/Workmoment7.jpg'
import mMoment8 from '../../../image/Gallery/MuswellHill/Workmoment8.jpg'
import mMoment9 from '../../../image/Gallery/MuswellHill/Workmoment9.jpg'
import mMoment10 from '../../../image/Gallery/MuswellHill/Workmoment10.jpg'
import mMoment11 from '../../../image/Gallery/MuswellHill/Workmoment11.jpg'
import mMoment12 from '../../../image/Gallery/MuswellHill/Workmoment12.jpg'
import mMoment13 from '../../../image/Gallery/MuswellHill/Workmoment13.jpg'
import mMoment14 from '../../../image/Gallery/MuswellHill/Workmoment14.jpg'
import mMoment15 from '../../../image/Gallery/MuswellHill/Workmoment15.jpg'
import mMoment16 from '../../../image/Gallery/MuswellHill/Workmoment16.jpg'
import mMoment17 from '../../../image/Gallery/MuswellHill/Workmoment17.jpg'
import mMoment18 from '../../../image/Gallery/MuswellHill/Workmoment18.jpg'
import mMoment19 from '../../../image/Gallery/MuswellHill/Workmoment19.jpg'
import mMoment20 from '../../../image/Gallery/MuswellHill/Workmoment20.jpg'
import mMoment21 from '../../../image/Gallery/MuswellHill/Workmoment21.jpg'
import mMoment22 from '../../../image/Gallery/MuswellHill/Workmoment22.jpg'
import mMoment23 from '../../../image/Gallery/MuswellHill/Workmoment23.jpg'
import mMoment24 from '../../../image/Gallery/MuswellHill/Workmoment24.jpg'
import mMoment25 from '../../../image/Gallery/MuswellHill/Workmoment25.jpg'

import Planting1 from '../../../image/Gallery/Planting/01fba2eb.jpg'
import Planting2 from '../../../image/Gallery/Planting/0c4eb163.jpg'
import Planting3 from '../../../image/Gallery/Planting/16cbc580.jpg'
import Planting4 from '../../../image/Gallery/Planting/272141b3.jpg'
import Planting5 from '../../../image/Gallery/Planting/27987b97.jpg'
import Planting6 from '../../../image/Gallery/Planting/5f6632d9.jpg'
import Planting7 from '../../../image/Gallery/Planting/6b17713c.jpg'
import Planting8 from '../../../image/Gallery/Planting/73fb2448.jpg'
import Planting9 from '../../../image/Gallery/Planting/b95934e6.jpg'
import Planting10 from '../../../image/Gallery/Planting/d6117bd6.jpg'
import Planting11 from '../../../image/Gallery/Planting/ef24d3b2.jpg'
import Planting12 from '../../../image/Gallery/Planting/xcvbnm.jpg'
import Planting13 from '../../../image/Gallery/Planting/liugty63365.jpg'
import Planting14 from '../../../image/Gallery/Planting/465ygtf56.jpg'
import Planting15 from '../../../image/Gallery/Planting/d6117bd67.jpg'
import Planting16 from '../../../image/Gallery/Planting/f75987y6.jpg'

import rProject1 from '../../../image/Gallery/Redbridge/Project1.jpg'
import rProject2 from '../../../image/Gallery/Redbridge/Project2.jpg'
import rProject3 from '../../../image/Gallery/Redbridge/Project3.jpg'
import rProject4 from '../../../image/Gallery/Redbridge/Project4.jpg'
import rReady1 from '../../../image/Gallery/Redbridge/Ready1.jpg'
import rReady2 from '../../../image/Gallery/Redbridge/Ready2.jpg'
import rReady3 from '../../../image/Gallery/Redbridge/Ready3.jpg'
import rReady4 from '../../../image/Gallery/Redbridge/Ready4.jpg'
import rMoment1 from '../../../image/Gallery/Redbridge/Workmoment1.jpg'
import rMoment2 from '../../../image/Gallery/Redbridge/Workmoment2.jpg'
import rMoment3 from '../../../image/Gallery/Redbridge/Workmoment3.jpg'
import rMoment4 from '../../../image/Gallery/Redbridge/Workmoment4.jpg'
import rMoment5 from '../../../image/Gallery/Redbridge/Workmoment5.jpg'
import rMoment6 from '../../../image/Gallery/Redbridge/Workmoment6.jpg'

import wBefore1 from '../../../image/Gallery/WoodfordGreen/Before1.jpg'
import wBefore2 from '../../../image/Gallery/WoodfordGreen/Before2.jpg'
import wBefore3 from '../../../image/Gallery/WoodfordGreen/Before3.jpg'
import wProject1 from '../../../image/Gallery/WoodfordGreen/Project1.jpg'
import wProject2 from '../../../image/Gallery/WoodfordGreen/Project2.jpg'
import wProject3 from '../../../image/Gallery/WoodfordGreen/Project3.jpg'
import wProject4 from '../../../image/Gallery/WoodfordGreen/Project4.jpg'
import wProject5 from '../../../image/Gallery/WoodfordGreen/Project5.jpg'
import wReady1 from '../../../image/Gallery/WoodfordGreen/Ready1.jpg'
import wReady2 from '../../../image/Gallery/WoodfordGreen/Ready2.jpg'
import wReady3 from '../../../image/Gallery/WoodfordGreen/Ready3.jpg'
import wReady4 from '../../../image/Gallery/WoodfordGreen/Ready4.jpg'
import wReady5 from '../../../image/Gallery/WoodfordGreen/Ready5.jpg'
import wReady6 from '../../../image/Gallery/WoodfordGreen/Ready6.jpg'
import wReady7 from '../../../image/Gallery/WoodfordGreen/Ready7.jpg'
import wReady8 from '../../../image/Gallery/WoodfordGreen/Ready8.jpg'
import wMoment1 from '../../../image/Gallery/WoodfordGreen/Workmoment1.jpg'
import wMoment2 from '../../../image/Gallery/WoodfordGreen/Workmoment2.jpg'
import wMoment3 from '../../../image/Gallery/WoodfordGreen/Workmoment3.jpg'
import wMoment4 from '../../../image/Gallery/WoodfordGreen/Workmoment4.jpg'
import wMoment5 from '../../../image/Gallery/WoodfordGreen/Workmoment5.jpg'
import wMoment6 from '../../../image/Gallery/WoodfordGreen/Workmoment6.jpg'
import wMoment7 from '../../../image/Gallery/WoodfordGreen/Workmoment7.jpg'
import wMoment8 from '../../../image/Gallery/WoodfordGreen/Workmoment8.jpg'
import wMoment9 from '../../../image/Gallery/WoodfordGreen/Workmoment9.jpg'

// 1MuswellHill imports
import mh1_1 from '../../../image/Gallery/1MuswellHill/1.JPG'
import mh1_2 from '../../../image/Gallery/1MuswellHill/2.JPG'
import mh1_3 from '../../../image/Gallery/1MuswellHill/2.JPG'
import mh1_4 from '../../../image/Gallery/1MuswellHill/3.JPG'
import mh1_5 from '../../../image/Gallery/1MuswellHill/4.JPG'
import mh1_6 from '../../../image/Gallery/1MuswellHill/5.JPG'
import mh1_7 from '../../../image/Gallery/1MuswellHill/6.JPG'
import mh1_8 from '../../../image/Gallery/1MuswellHill/7.JPG'
import mh1_9 from '../../../image/Gallery/1MuswellHill/8.JPG'
import mh1_10 from '../../../image/Gallery/1MuswellHill/9.JPG'
import mh1_11 from '../../../image/Gallery/1MuswellHill/10.JPG'
import mh1_12 from '../../../image/Gallery/1MuswellHill/11.JPG'
import mh1_13 from '../../../image/Gallery/1MuswellHill/12.JPG'
import mh1_14 from '../../../image/Gallery/1MuswellHill/13.JPG'
import mh1_15 from '../../../image/Gallery/1MuswellHill/14.JPG'
import mh1_16 from '../../../image/Gallery/1MuswellHill/15.JPG'
import mh1_17 from '../../../image/Gallery/1MuswellHill/16.JPG'
import mh1_18 from '../../../image/Gallery/1MuswellHill/17.JPG'
import mh1_19 from '../../../image/Gallery/1MuswellHill/18.JPG'
import mh1_20 from '../../../image/Gallery/1MuswellHill/19.JPG'
import mh1_21 from '../../../image/Gallery/1MuswellHill/20.JPG'
import mh1_22 from '../../../image/Gallery/1MuswellHill/21.JPG'
import mh1_23 from '../../../image/Gallery/1MuswellHill/22.JPG'

// 2Hackney imports
import h2_1 from '../../../image/Gallery/2Hackney/1.JPG'
import h2_2 from '../../../image/Gallery/2Hackney/2.JPG'
import h2_3 from '../../../image/Gallery/2Hackney/3.JPG'
import h2_4 from '../../../image/Gallery/2Hackney/4.JPG'
import h2_5 from '../../../image/Gallery/2Hackney/5.JPG'
import h2_6 from '../../../image/Gallery/2Hackney/6.JPG'
import h2_7 from '../../../image/Gallery/2Hackney/7.JPG'
import h2_8 from '../../../image/Gallery/2Hackney/8.JPG'
import h2_9 from '../../../image/Gallery/2Hackney/9.JPG'
import h2_10 from '../../../image/Gallery/2Hackney/10.JPG'
import h2_11 from '../../../image/Gallery/2Hackney/11.JPG'
import h2_12 from '../../../image/Gallery/2Hackney/12.JPG'
import h2_13 from '../../../image/Gallery/2Hackney/13.JPG'
import h2_14 from '../../../image/Gallery/2Hackney/14.JPG'
import h2_15 from '../../../image/Gallery/2Hackney/15.JPG'

// 2MuswellHill imports
import mh2_1 from '../../../image/Gallery/2MuswellHill/1.JPG'
import mh2_2 from '../../../image/Gallery/2MuswellHill/2.JPG'
import mh2_3 from '../../../image/Gallery/2MuswellHill/3.JPG'
import mh2_4 from '../../../image/Gallery/2MuswellHill/4.JPG'
import mh2_5 from '../../../image/Gallery/2MuswellHill/5.JPG'
import mh2_6 from '../../../image/Gallery/2MuswellHill/6.JPG'
import mh2_7 from '../../../image/Gallery/2MuswellHill/7.JPG'
import mh2_8 from '../../../image/Gallery/2MuswellHill/8.JPG'
import mh2_9 from '../../../image/Gallery/2MuswellHill/9.JPG'
import mh2_10 from '../../../image/Gallery/2MuswellHill/10.JPG'
import mh2_11 from '../../../image/Gallery/2MuswellHill/11.JPG'
import mh2_12 from '../../../image/Gallery/2MuswellHill/12.JPG'
import mh2_13 from '../../../image/Gallery/2MuswellHill/13.JPG'
import mh2_14 from '../../../image/Gallery/2MuswellHill/14.JPG'
import mh2_15 from '../../../image/Gallery/2MuswellHill/15.JPG'
import mh2_16 from '../../../image/Gallery/2MuswellHill/16.JPG'
import mh2_17 from '../../../image/Gallery/2MuswellHill/17.JPG'
import mh2_18 from '../../../image/Gallery/2MuswellHill/18.JPG'
import mh2_19 from '../../../image/Gallery/2MuswellHill/19.JPG'
import mh2_20 from '../../../image/Gallery/2MuswellHill/20.JPG'
import mh2_21 from '../../../image/Gallery/2MuswellHill/21.JPG'
import mh2_22 from '../../../image/Gallery/2MuswellHill/22.JPG'

// 3MuswellHill imports
import mh3_1 from '../../../image/Gallery/3MuswellHill/1.JPG'
import mh3_2 from '../../../image/Gallery/3MuswellHill/2.JPG'
import mh3_3 from '../../../image/Gallery/3MuswellHill/3.JPG'
import mh3_4 from '../../../image/Gallery/3MuswellHill/4.JPG'
import mh3_5 from '../../../image/Gallery/3MuswellHill/5.JPG'
import mh3_6 from '../../../image/Gallery/3MuswellHill/6.JPG'
import mh3_7 from '../../../image/Gallery/3MuswellHill/7.JPG'
import mh3_8 from '../../../image/Gallery/3MuswellHill/8.JPG'
import mh3_9 from '../../../image/Gallery/3MuswellHill/9.JPG'
import mh3_10 from '../../../image/Gallery/3MuswellHill/10.JPG'
import mh3_11 from '../../../image/Gallery/3MuswellHill/11.JPG'
import mh3_12 from '../../../image/Gallery/3MuswellHill/12.JPG'
import mh3_13 from '../../../image/Gallery/3MuswellHill/13.JPG'
import mh3_14 from '../../../image/Gallery/3MuswellHill/14.JPG'
import mh3_15 from '../../../image/Gallery/3MuswellHill/15.JPG'
import mh3_16 from '../../../image/Gallery/3MuswellHill/16.JPG'
import mh3_17 from '../../../image/Gallery/3MuswellHill/17.JPG'
import mh3_18 from '../../../image/Gallery/3MuswellHill/18.JPG'
import mh3_19 from '../../../image/Gallery/3MuswellHill/19.JPG'

// 4MuswellHill imports
import mh4_1 from '../../../image/Gallery/4MuswellHill/1.jpg'
import mh4_2 from '../../../image/Gallery/4MuswellHill/2.jpg'
import mh4_3 from '../../../image/Gallery/4MuswellHill/3.jpg'
import mh4_4 from '../../../image/Gallery/4MuswellHill/4.jpg'
import mh4_5 from '../../../image/Gallery/4MuswellHill/5.jpg'
import mh4_6 from '../../../image/Gallery/4MuswellHill/6.jpg'
import mh4_7 from '../../../image/Gallery/4MuswellHill/7.jpg'
import mh4_8 from '../../../image/Gallery/4MuswellHill/8.jpg'
import mh4_9 from '../../../image/Gallery/4MuswellHill/9.jpg'
import mh4_10 from '../../../image/Gallery/4MuswellHill/10.jpg'
import mh4_11 from '../../../image/Gallery/4MuswellHill/11.jpeg'
import mh4_12 from '../../../image/Gallery/4MuswellHill/12.JPG'
import mh4_13 from '../../../image/Gallery/4MuswellHill/13.JPG'
import mh4_14 from '../../../image/Gallery/4MuswellHill/14.JPG'
import mh4_15 from '../../../image/Gallery/4MuswellHill/15.jpeg'
import mh4_16 from '../../../image/Gallery/4MuswellHill/16.jpeg'
import mh4_17 from '../../../image/Gallery/4MuswellHill/17.jpeg'
import mh4_18 from '../../../image/Gallery/4MuswellHill/18.jpeg'
import mh4_19 from '../../../image/Gallery/4MuswellHill/19.jpeg'
import mh4_20 from '../../../image/Gallery/4MuswellHill/20.jpeg'
import mh4_21 from '../../../image/Gallery/4MuswellHill/21.jpeg'
import mh4_22 from '../../../image/Gallery/4MuswellHill/22.jpeg'
import mh4_23 from '../../../image/Gallery/4MuswellHill/23.jpeg'
import mh4_24 from '../../../image/Gallery/4MuswellHill/24.jpeg'
import mh4_25 from '../../../image/Gallery/4MuswellHill/25.jpeg'
import mh4_26 from '../../../image/Gallery/4MuswellHill/26.jpeg'
import mh4_27 from '../../../image/Gallery/4MuswellHill/27.jpeg'

// belsizePark imports
import bp_1 from '../../../image/Gallery/belsizePark/1.JPG'
import bp_2 from '../../../image/Gallery/belsizePark/2.JPG'
import bp_3 from '../../../image/Gallery/belsizePark/3.JPG'
import bp_4 from '../../../image/Gallery/belsizePark/4.JPG'
import bp_5 from '../../../image/Gallery/belsizePark/5.JPG'
import bp_6 from '../../../image/Gallery/belsizePark/6.JPG'
import bp_7 from '../../../image/Gallery/belsizePark/7.JPG'
import bp_8 from '../../../image/Gallery/belsizePark/8.JPG'
import bp_9 from '../../../image/Gallery/belsizePark/9.JPG'
import bp_10 from '../../../image/Gallery/belsizePark/10.JPG'
import bp_11 from '../../../image/Gallery/belsizePark/11.JPG'
import bp_12 from '../../../image/Gallery/belsizePark/12.JPG'
import bp_13 from '../../../image/Gallery/belsizePark/13.JPG'
import bp_14 from '../../../image/Gallery/belsizePark/14.JPG'
import bp_15 from '../../../image/Gallery/belsizePark/15.JPG'
import bp_16 from '../../../image/Gallery/belsizePark/16.JPG'

// Hackney imports
import h_1 from '../../../image/Gallery/Hackney/1.JPG'
import h_2 from '../../../image/Gallery/Hackney/2.JPG'
import h_3 from '../../../image/Gallery/Hackney/3.JPG'
import h_4 from '../../../image/Gallery/Hackney/4.JPG'
import h_5 from '../../../image/Gallery/Hackney/5.JPG'
import h_6 from '../../../image/Gallery/Hackney/6.JPG'
import h_7 from '../../../image/Gallery/Hackney/7.JPG'
import h_8 from '../../../image/Gallery/Hackney/8.JPG'
import h_9 from '../../../image/Gallery/Hackney/9.JPG'
import h_10 from '../../../image/Gallery/Hackney/10.JPG'
import h_11 from '../../../image/Gallery/Hackney/11.JPG'
import h_12 from '../../../image/Gallery/Hackney/12.JPG'

// hampsteadSububanArea imports
import hs_1 from '../../../image/Gallery/hampsteadSububanArea/1.JPG'
import hs_2 from '../../../image/Gallery/hampsteadSububanArea/2.JPG'
import hs_3 from '../../../image/Gallery/hampsteadSububanArea/3.JPG'
import hs_4 from '../../../image/Gallery/hampsteadSububanArea/4.JPG'
import hs_5 from '../../../image/Gallery/hampsteadSububanArea/5.JPG'
import hs_6 from '../../../image/Gallery/hampsteadSububanArea/6.JPG'
import hs_7 from '../../../image/Gallery/hampsteadSububanArea/7.JPG'
import hs_8 from '../../../image/Gallery/hampsteadSububanArea/8.JPG'
import hs_9 from '../../../image/Gallery/hampsteadSububanArea/9.JPG'
import hs_10 from '../../../image/Gallery/hampsteadSububanArea/10.JPG'

// Highbury imports
import hb_1 from '../../../image/Gallery/Highbury/1.JPG'
import hb_2 from '../../../image/Gallery/Highbury/2.JPG'
import hb_3 from '../../../image/Gallery/Highbury/3.JPG'
import hb_4 from '../../../image/Gallery/Highbury/4.JPG'
import hb_5 from '../../../image/Gallery/Highbury/5.JPG'
import hb_6 from '../../../image/Gallery/Highbury/6.JPG'
import hb_7 from '../../../image/Gallery/Highbury/7.JPG'
import hb_8 from '../../../image/Gallery/Highbury/8.JPG'
import hb_9 from '../../../image/Gallery/Highbury/9.JPG'
import hb_10 from '../../../image/Gallery/Highbury/10.JPG'
import hb_11 from '../../../image/Gallery/Highbury/11.JPG'
import hb_12 from '../../../image/Gallery/Highbury/12.JPG'
import hb_13 from '../../../image/Gallery/Highbury/13.JPG'
import hb_14 from '../../../image/Gallery/Highbury/14.JPG'
import hb_15 from '../../../image/Gallery/Highbury/15.JPG'

// leinsterRoadMuswellHill imports
import lr_1 from '../../../image/Gallery/leinsterRoadMuswellHill/1.JPG'
import lr_2 from '../../../image/Gallery/leinsterRoadMuswellHill/2.JPG'
import lr_3 from '../../../image/Gallery/leinsterRoadMuswellHill/3.MP4'
import lr_4 from '../../../image/Gallery/leinsterRoadMuswellHill/4.JPG'
import lr_5 from '../../../image/Gallery/leinsterRoadMuswellHill/5.JPG'
import lr_6 from '../../../image/Gallery/leinsterRoadMuswellHill/6.JPG'
import lr_7 from '../../../image/Gallery/leinsterRoadMuswellHill/7.JPG'
import lr_8 from '../../../image/Gallery/leinsterRoadMuswellHill/8.JPG'
import lr_9 from '../../../image/Gallery/leinsterRoadMuswellHill/9.JPG'
import lr_10 from '../../../image/Gallery/leinsterRoadMuswellHill/10.JPG'
import lr_11 from '../../../image/Gallery/leinsterRoadMuswellHill/11.MP4'

// palmersGreen imports
import pg_1 from '../../../image/Gallery/palmersGreen/1.JPG'
import pg_2 from '../../../image/Gallery/palmersGreen/2.JPG'
import pg_3 from '../../../image/Gallery/palmersGreen/3.JPG'
import pg_4 from '../../../image/Gallery/palmersGreen/4.JPG'
import pg_5 from '../../../image/Gallery/palmersGreen/5.JPG'
import pg_6 from '../../../image/Gallery/palmersGreen/6.JPG'
import pg_7 from '../../../image/Gallery/palmersGreen/7.JPG'
import pg_8 from '../../../image/Gallery/palmersGreen/8.JPG'
import pg_9 from '../../../image/Gallery/palmersGreen/9.JPG'
import pg_10 from '../../../image/Gallery/palmersGreen/10.JPG'
import pg_11 from '../../../image/Gallery/palmersGreen/11.JPG'
import pg_12 from '../../../image/Gallery/palmersGreen/12.JPG'
import pg_13 from '../../../image/Gallery/palmersGreen/13.JPG'
import pg_14 from '../../../image/Gallery/palmersGreen/14.JPG'
import pg_15 from '../../../image/Gallery/palmersGreen/15.JPG'
import pg_16 from '../../../image/Gallery/palmersGreen/16.JPG'
import pg_17 from '../../../image/Gallery/palmersGreen/17.JPG'
import pg_18 from '../../../image/Gallery/palmersGreen/18.JPG'
import pg_19 from '../../../image/Gallery/palmersGreen/19.JPG'
import pg_20 from '../../../image/Gallery/palmersGreen/20.JPG'
import pg_21 from '../../../image/Gallery/palmersGreen/21.JPG'

export const projects = {
  'Woodford Green': [
    { img: wBefore1 },
    { img: wBefore2 },
    { img: wBefore3 },
    { img: wMoment1 },
    { img: wMoment2 },
    { img: wMoment3 },
    { img: wMoment4 },
    { img: wMoment5 },
    { img: wMoment6 },
    { img: wMoment7 },
    { img: wMoment8 },
    { img: wMoment9 },
    { img: wProject1 },
    { img: wProject2 },
    { img: wProject3 },
    { img: wProject4 },
    { img: wProject5 },
    { img: wReady1 },
    { img: wReady2 },
    { img: wReady3 },
    { img: wReady4 },
    { img: wReady5 },
    { img: wReady6 },
    { img: wReady7 },
    { img: wReady8 },
  ],
  'Redbridge': [
    { img: rMoment1 },
    { img: rMoment2 },
    { img: rMoment3 },
    { img: rMoment4 },
    { img: rMoment5 },
    { img: rMoment6 },
    { img: rProject1 },
    { img: rProject2 },
    { img: rProject3 },
    { img: rProject4 },
    { img: rReady1 },
    { img: rReady2 },
    { img: rReady3 },
    { img: rReady4 },
  ],
  'Planting': [
    { img: Planting1 },
    { img: Planting2 },
    { img: Planting3 },
    { img: Planting4 },
    { img: Planting5 },
    { img: Planting6 },
    { img: Planting7 },
    { img: Planting8 },
    { img: Planting9 },
    { img: Planting10 },
    { img: Planting11 },
    { img: Planting12 },
    { img: Planting13 },
    { img: Planting14 },
    { img: Planting15 },
    { img: Planting16 },
  ],
  'Highgate':  [
    { img: mBefore1New },
    { img: mBefore2New },
    { img: mBefore3New },
    { img: mBefore4New },
    { img: mBefore1 },
    { img: mBefore2 },
    { img: mBefore3 },
    { img: mBefore4 },
    { img: mMoment1 },
    { img: mMoment2 },
    { img: mMoment3 },
    { img: mMoment4 },
    { img: mMoment5 },
    { img: mMoment6 },
    { img: mMoment7 },
    { img: mMoment8 },
    { img: mMoment9 },
    { img: mMoment10 },
    { img: mMoment11 },
    { img: mMoment12 },
    { img: mMoment13 },
    { img: mMoment14 },
    { img: mMoment15 },
    { img: mMoment16 },
    { img: mMoment17 },
    { img: mMoment18 },
    { img: mMoment19 },
    { img: mMoment20 },
    { img: mMoment21 },
    { img: mMoment22 },
    { img: mMoment23 },
    { img: mMoment24 },
    { img: mMoment25 },
    { img: mProject1 },
    { img: mProject2 },
    { img: mProject3 },
    { img: mProject4 },
    { img: mProject5 },
    { img: mProject6 },
    { img: mProject7 },
    { img: mProject8 },
    { img: mProject9 },
    { img: mProject10 },
    { img: mMoment20 },
    { img: mMoment21 },
    { img: mMoment22 },
    { img: mMoment23 },
    { img: mMoment24 },
    { img: mMoment25 },
    { img: mProject1 },
    { img: mProject2 },
  ],
  'Loughton': [
    { img: lBefore1 },
    { img: lBefore2 },
    { img: lProjectPic1 },
    { img: lProjectPic2 },
    { img: lProjectPic3 },
    { img: lProjectPic4 },
    { img: lProjectPic5 },
    { img: lProjectPic6 },
    { img: lReady1 },
    { img: lReady2 },
    { img: lReady3 },
    { img: lReady4 },
    { img: lReady5 },
    { img: lmoment },
    { img: lmoment2 },
  ],
  'Hadley Wood': [
    { img: hProject1 },
    { img: hProject2 },
    { img: hProject3 },
    { img: hProject4 },
    { img: hProject5 },
    { img: hProject6 },
    { img: hProject7 },
    { img: hProject8 },
    { img: hProject9 },
    { img: hReady1 },
    { img: hReady2 },
    { img: hReady3 },
    { img: hReady4 },
    { img: hReady5 },
    { img: hReady6 },
    { img: hReady7 },
    { img: hReady8 },
    { img: hReady9 },
    { img: hReady10 },
    { img: hReady11 },
    { img: hReady12 },
    { img: hReady13 },
  ],
  'East Finchley': [
    { img: eBefore1 },
    { img: eBefore2 },
    { img: eBefore3 },
    { img: eProject1 },
    { img: eProject2 },
    { img: eProject3 },
    { img: eProject4 },
    { img: eProject5 },
    { img: eReady1 },
    { img: eReady2 },
    { img: eReady3 },
    { img: eReady4 },
    { img: eReady5 },
    { img: eReady6 },
    { img: eReady7 },
    { img: eReady8 },
    { img: eReady9 },
    { img: eReady10 },
    { img: eReady11 },
    { img: eReady12 },
  ],
  'Crouch Hill':  [
    { img: Before1 },
    { img: Before2 },
    { img: Before3 },
    { img: Before4 },
    { img: Project1 },
    { img: Project2 },
    { img: moment1 },
    { img: moment2 },
    { img: moment3 },
    { img: moment4 },
    { img: moment5 },
    { img: moment6 },
    { img: moment7 },
    { img: moment8 },
    { img: moment9 },
    { img: moment10 },
    { img: moment11 },
    { img: moment12 },
    { img: moment13 },
    { img: moment14 },
    { img: moment15 },
    { img: Read1 },
    { img: Read2 },
    { img: Read3 },
    { img: Read4 },
    { img: Read5 },
    { img: Read6 },
    { img: Read7 },
    { img: Read8 },
    { img: Read9 },
    { img: Read10 },
    { img: Ready11 },
  ],
  '1 Muswell Hill': [
    { img: mh1_1 },
    { img: mh1_2 },
    { img: mh1_3 },
    { img: mh1_4 },
    { img: mh1_5 },
    { img: mh1_6 },
    { img: mh1_7 },
    { img: mh1_8 },
    { img: mh1_9 },
    { img: mh1_10 },
    { img: mh1_11 },
    { img: mh1_12 },
    { img: mh1_13 },
    { img: mh1_14 },
    { img: mh1_15 },
    { img: mh1_16 },
    { img: mh1_17 },
    { img: mh1_18 },
    { img: mh1_19 },
    { img: mh1_20 },
    { img: mh1_21 },
    { img: mh1_22 },
    { img: mh1_23 },
  ],
  '2 Hackney': [
    { img: h2_1 },
    { img: h2_2 },
    { img: h2_3 },
    { img: h2_4 },
    { img: h2_5 },
    { img: h2_6 },
    { img: h2_7 },
    { img: h2_8 },
    { img: h2_9 },
    { img: h2_10 },
    { img: h2_11 },
    { img: h2_12 },
    { img: h2_13 },
    { img: h2_14 },
    { img: h2_15 },
  ],
  '2 Muswell Hill': [
    { img: mh2_1 },
    { img: mh2_2 },
    { img: mh2_3 },
    { img: mh2_4 },
    { img: mh2_5 },
    { img: mh2_6 },
    { img: mh2_7 },
    { img: mh2_8 },
    { img: mh2_9 },
    { img: mh2_10 },
    { img: mh2_11 },
    { img: mh2_12 },
    { img: mh2_13 },
    { img: mh2_14 },
    { img: mh2_15 },
    { img: mh2_16 },
    { img: mh2_17 },
    { img: mh2_18 },
    { img: mh2_19 },
    { img: mh2_20 },
    { img: mh2_21 },
    { img: mh2_22 },
  ],
  '3 Muswell Hill': [
    { img: mh3_1 },
    { img: mh3_2 },
    { img: mh3_3 },
    { img: mh3_4 },
    { img: mh3_5 },
    { img: mh3_6 },
    { img: mh3_7 },
    { img: mh3_8 },
    { img: mh3_9 },
    { img: mh3_10 },
    { img: mh3_11 },
    { img: mh3_12 },
    { img: mh3_13 },
    { img: mh3_14 },
    { img: mh3_15 },
    { img: mh3_16 },
    { img: mh3_17 },
    { img: mh3_18 },
    { img: mh3_19 },
  ],
  '4 Muswell Hill': [
    { img: mh4_1 },
    { img: mh4_2 },
    { img: mh4_3 },
    { img: mh4_4 },
    { img: mh4_5 },
    { img: mh4_6 },
    { img: mh4_7 },
    { img: mh4_8 },
    { img: mh4_9 },
    { img: mh4_10 },
    { img: mh4_11 },
    { img: mh4_12 },
    { img: mh4_13 },
    { img: mh4_14 },
    { img: mh4_15 },
    { img: mh4_16 },
    { img: mh4_17 },
    { img: mh4_18 },
    { img: mh4_19 },
    { img: mh4_20 },
    { img: mh4_21 },
    { img: mh4_22 },
    { img: mh4_23 },
    { img: mh4_24 },
    { img: mh4_25 },
    { img: mh4_26 },
    { img: mh4_27 },
  ],
  'Belsize Park': [
    { img: bp_1 },
    { img: bp_2 },
    { img: bp_3 },
    { img: bp_4 },
    { img: bp_5 },
    { img: bp_6 },
    { img: bp_7 },
    { img: bp_8 },
    { img: bp_9 },
    { img: bp_10 },
    { img: bp_11 },
    { img: bp_12 },
    { img: bp_13 },
    { img: bp_14 },
    { img: bp_15 },
    { img: bp_16 },
  ],
  'Hackney': [
    { img: h_1 },
    { img: h_2 },
    { img: h_3 },
    { img: h_4 },
    { img: h_5 },
    { img: h_6 },
    { img: h_7 },
    { img: h_8 },
    { img: h_9 },
    { img: h_10 },
    { img: h_11 },
    { img: h_12 },
  ],
  'Hampstead Suburban Area': [
    { img: hs_1 },
    { img: hs_2 },
    { img: hs_3 },
    { img: hs_4 },
    { img: hs_5 },
    { img: hs_6 },
    { img: hs_7 },
    { img: hs_8 },
    { img: hs_9 },
    { img: hs_10 },
  ],
  'Highbury': [
    { img: hb_1 },
    { img: hb_2 },
    { img: hb_3 },
    { img: hb_4 },
    { img: hb_5 },
    { img: hb_6 },
    { img: hb_7 },
    { img: hb_8 },
    { img: hb_9 },
    { img: hb_10 },
    { img: hb_11 },
    { img: hb_12 },
    { img: hb_13 },
    { img: hb_14 },
    { img: hb_15 },
  ],
  'Leinster Road Muswell Hill': [
    { img: lr_1 },
    { img: lr_2 },
    { img: lr_3 },
    { img: lr_4 },
    { img: lr_5 },
    { img: lr_6 },
    { img: lr_7 },
    { img: lr_8 },
    { img: lr_9 },
    { img: lr_10 },
    { img: lr_11 },
  ],
  'Palmers Green': [
    { img: pg_1 },
    { img: pg_2 },
    { img: pg_3 },
    { img: pg_4 },
    { img: pg_5 },
    { img: pg_6 },
    { img: pg_7 },
    { img: pg_8 },
    { img: pg_9 },
    { img: pg_10 },
    { img: pg_11 },
    { img: pg_12 },
    { img: pg_13 },
    { img: pg_14 },
    { img: pg_15 },
    { img: pg_16 },
    { img: pg_17 },
    { img: pg_18 },
    { img: pg_19 },
    { img: pg_20 },
    { img: pg_21 },
  ],
}